import { Box, Flex, Text } from "@chakra-ui/react";
import Keyboard from "@/components/keyboard";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUserInfo } from "@/context/UserInfo";
import { LogsButton } from "@/components/Button";
import { GoIcon } from "@/components/icons";
import { createOrder } from "@/api/order";
import { accDiv, accMul, parseAmount, toFixed } from "@/utils/formatBalance";
import { usdcInfo } from "@/constants/tokens";
import TitleHeader from "@/components/TitleHeader";
import { useCurrencyExchange } from "@/hooks/useCurrencyExchange";

const Charge = () => {
  const [value, setValue] = useState("0");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { smartAccount, showUsd, taxRate } = useUserInfo();
  const { usdToCurrency, localConvertToUsd, currencyUnit } =
    useCurrencyExchange();

  const handleCreateOrder = async () => {
    if (loading || value === "0") return;

    setLoading(true);
    try {
      let amount = parseAmount(value, usdcInfo.decimals);
      if (!showUsd) {
        amount = localConvertToUsd(amount);
      }

      const order = await createOrder({
        orderAmount: amount,
        taxRate: taxRate,
      });
      setLoading(false);
      navigate(`/charge/${order.id}`);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <Flex
      flexDir={"column"}
      align={"center"}
      sx={{
        height: "100%",
        padding: "20px 20px 240px",
        position: "relative",
      }}
    >
      <TitleHeader
        color="#D8762B"
        onBack={() => navigate("/")}
        title="Charge"
        showSwitch={true}
      />
      <Text
        sx={{
          marginTop: "20px",
          color: "#848484",
          fontSize: "14px",
          fontWeight: 700,
        }}
      >
        Amount
      </Text>
      <Box
        sx={{
          position: "relative",
          padding: "0 20px",
        }}
      >
        <Text
          sx={{
            fontSize: "70px",
            fontStyle: "normal",
            fontWeight: 900,
            minHeight: "70px",
            textAlign: "center",
            position: "relative",
            wordBreak: "break-all",
            fontFamily: "DIN-Black",
          }}
        >
          {value}
        </Text>
      </Box>
      <Text
        sx={{
          fontSize: "20px",
          fontStyle: "normal",
          fontWeight: 500,
        }}
      >
        {currencyUnit}
      </Text>

      <LogsButton
        variant="outlined"
        sx={{
          width: "160px",
          height: "70px",
          borderRadius: "100px",
          marginTop: "16px",
        }}
        loading={loading}
        onClick={() => {
          handleCreateOrder();
        }}
      >
        <Text
          sx={{
            marginLeft: "auto",
            marginRight: "20px",
          }}
        >
          Next
        </Text>
        <GoIcon
          style={{
            width: "14px",
            height: "11px",
            marginRight: "30px",
          }}
        ></GoIcon>
      </LogsButton>

      <Keyboard
        value={value}
        onKeyboardClick={(value: string) => {
          setValue(value);
        }}
      ></Keyboard>
    </Flex>
  );
};

export default Charge;
